import { Box, Button, Stack, TableCell, TableRow, useTheme } from '@mui/material'
import AppsIcon from '@mui/icons-material/Apps'
import { useState } from 'react';
import { filterHeaders } from './const'
import { updateModal } from '../../../../store/common/common_action'
import { connect } from 'react-redux'
import { useEffect } from 'react';
import moment from 'moment/moment'
import LRStatusModel from './LRStatusModel';
import { useAtom } from 'jotai';
import { BookingLRTrackStatusData, fetchLRStatusData } from '../../../common/jotaiState/reportStateAtom';
import { companySettingsAtom } from '../../../common/jotaiState/commonStateAtoms';
import { exportToExcel } from '../../../common/hook';
import VirtualizedTable from '../../../common/virtualisedTable';
import { Item } from '../../../common/snippets';

const BkngDelvryTrackingTable = (props) => {
    const { updateModal, dataValues, reportName, filterObj,manageColumn } = props
    const { trackingReportTableData, loginData } = dataValues
    const theme = useTheme()
    const { tableHeaderColor } = theme
    const [tableData, setTableData] = useState([])
    const currentDateTime = moment(window.getTime ? window.getTime() : new Date()).format('DD-MMM-YYYY HH:mm');
    const [openLrModal, setOpenLrModal] = useState(false)
    const [LRTrackStatusData] = useAtom(BookingLRTrackStatusData)
    const [companySettings] = useAtom(companySettingsAtom)
    const { DefaultCurrencyID = 0 } = companySettings
    const [, fetchLRStatus] = useAtom(fetchLRStatusData)
    const detailedHeaders = manageColumn.map((col) => {
        return {
            ...col,
            header: col.header,
            exportHead: col.exportHead,
            align: col.align || (col.xlCol?.dataType === 'quantity' ? 'right' : 'left'),
            weight: Math.max(col.weight || 0, 140),
        }
    })
    const header1 = [
        [{ header: 'Report For: Booking Report', field: '', span: detailedHeaders.length, mainHeader: true }],
    ]
    useEffect(() => {

        if (!trackingReportTableData?.length || !manageColumn?.length) {
            setTableData([])
            return
        }

        const newData = trackingReportTableData.map((item, index) => ({
            ...item,
            SN: index + 1,
            CartageCharge:
                Number(item.PickupCartage || 0) +
                Number(item.CommCartage || 0) +
                Number(item.ReturnCartage || 0) +
                Number(item.MsclCart || 0) +
                Number(item.DeliveryCartage || 0),
            'LRNO^^ManualLRNo': `${item.LRNO ?? ''}\n${item.ManualLRNo ?? ''}`,
            'SourceCity^^SourceBranch': `${item.SourceCity ?? ''}\n${item.SourceBranch ?? ''}`,
            'DestCity^^DestBranch': `${item.DestCity ?? ''}\n${item.DestBranch ?? ''}`,
            'Sender^^SenderMobileNo': `${item.Sender ?? ''}\n${item.SenderMobileNo ?? ''}`,
            'RecName^^RecMobileNo': `${item.RecName ?? ''}\n${item.RecMobileNo ?? ''}`,
            'PartyBillNo^^PartyBillDate': `${item.PartyBillNo ?? ''}\n${item.PartyBillDate ?? ''}`,
            BookingDate: item?.BookingDate?.split(' ')[0] || '',
            BookingTime: item?.BookingDate?.split(' ').slice(1).join(' ') || '',
            RefundDate: item?.RefundDate?.split(' ')[0] || '',
            RefundTime: item?.RefundDate?.split(' ').slice(1).join(' ') || '',
            dataType: 'entry',

        }))

        const totalRow = calculateTotal(newData, manageColumn)

        setTableData([...newData, totalRow])

    }, [trackingReportTableData, manageColumn])
    const calculateTotal = (data = [], manageColumn = []) => {
        if (!data.length) return {}
        const visibleHeaders = manageColumn.filter(col => col.isSelected !== false)
        const numericCols = visibleHeaders.filter(
            col => col.xlCol?.dataType === 'quantity'
        )
        const totalFields = numericCols.map(col => col.field)
        const firstNumericIndex = visibleHeaders.findIndex(
            col => col.xlCol?.dataType === 'quantity'
        )
        const firstField = visibleHeaders[0]?.field

        let totalRow = {
            dataType: 'total',
            [firstField]: 'Total',
            colSpan: {
                [firstField]: firstNumericIndex > 0 ? firstNumericIndex : 1
            }
        }

        totalFields.forEach(field => {
            totalRow[field] = 0
        })

        data.forEach(row => {
            totalFields.forEach(field => {
                let value = row[field]

                if (
                    (field === 'AWEIGHT' || field === 'CWEIGHT') &&
                    typeof value === 'string'
                ) {
                    value = value
                        ?.split(',')
                        ?.reduce((a, b) => a + Number(b || 0), 0)
                }

                totalRow[field] = Number(
                    (Number(totalRow[field]) + Number(value || 0)).toFixed(2)
                )
            })
        })

        return totalRow
    }
    const headerContent = () => {
        return (
            <>
                <TableRow>
                    <TableCell
                        className="reportTD"
                        style={{
                            fontWeight: 'bold',
                            fontSize: '12px',
                            lineheight: '16px',
                            letterspacing: '0.24px',
                            fontWeight: '500',
                            textAlign: 'left',
                            color: '#444444',
                            backgroundColor: '#bfe1ff',
                            position: 'sticky',
                            top: '0px',
                            height: '36px',
                            padding: '10px 4px',
                        }}
                        colSpan={detailedHeaders.length}
                    >
                        {reportName}
                    </TableCell>
                </TableRow>
                <TableRow style={{ height: '47px' }}>
                    {detailedHeaders.map((item) => {
                        const align =
                            item?.xlCol?.dataType === "string"
                                ? "left"
                                : "right";
                        return (
                            <TableCell
                                align={align}
                                style={{
                                    ...item?.headerSx,
                                    backgroundColor: '#e5f3ff',
                                    color: '#444',
                                    fontSize: '12px',
                                    lineheight: '16px',
                                    letterspacing: '0.24px',
                                    fontWeight: '600',
                                    whiteSpace: 'nowrap',
                                    padding: '10px 4px',
                                }}
                                colSpan={1}
                            >
                                {item?.header}
                            </TableCell>
                        )
                    })}
                </TableRow>
            </>
        )
    }
    const DisPatchBody = ({ row, index, tableHeaderColor, columnDefs }) => {

        if (!row?.dataType) return null

        const getStyles = (align) => ({
            minHeight: '36px',
            fontSize: '12px',
            padding: '8px 4px',
            fontWeight: row.dataType === 'total' ? 700 : 500,
            backgroundColor: row.dataType === 'total' ? tableHeaderColor?.isTotalColor : '#fff',
            textAlign: align || (row.dataType === 'total' ? 'right' : 'left'),
            whiteSpace: 'nowrap'
        })

        return (
            <>
                {(() => {
                    let skip = 0

                    return columnDefs.map((item, i) => {

                        if (skip > 0) {
                            skip--
                            return null
                        }

                        const colSpan = row.colSpan?.[item.field] || 1
                        skip = colSpan - 1

                        let cellValue = row[item.field]
                        if (
                            row.dataType === 'entry' &&
                            item.field === 'LRNO'
                        ) {
                            cellValue = (
                                <span
                                    style={{
                                        color: '#1976d2',
                                        cursor: 'pointer',
                                        textDecoration: 'underline'
                                    }}
                                    onClick={() => handleOpenModal(row)}
                                >
                                    {row.LRNO}
                                </span>
                            )
                        }

                        return (
                            <TableCell
                                key={item.field + i + index}
                                colSpan={colSpan}
                                style={getStyles(item.align)}
                            >
                                {cellValue}
                            </TableCell>
                        )
                    })
                })()}
            </>
        )
    }
    const bodyContent = (index, obj) => {
        return <DisPatchBody row={obj} index={index} tableHeaderColor={tableHeaderColor} columnDefs={detailedHeaders} />
    }
    const handleOpenModal = (lrData) => {
        if (DefaultCurrencyID === 2) {
            setOpenLrModal(true)
            const obj = {
                intCompanyID: loginData.intCompanyID,
                intBranchID: loginData.intBranchID,
                strLRNo: lrData.LRNO,
                intUserID: loginData.intUserID
            }
            fetchLRStatus(obj)
        }
    }
    return (
        <>
            <Box className="userReport" style={{ display: 'flex', width: '100%', height: '40px', padding: '12px 0px', marginRight: '0px', marginTop: '5px' }}>
                <Box style={{ display: 'flex', width: '50%', justifyContent: 'flex-start', alignItems: 'center', gap: '12px', fontSize: '14px' }}>
                    <h3 style={{ textAlign: 'left', color: '#444', paddingLeft: '16px' }}>Report For: Booking And Delivery Tacking</h3>
                    <Box
                        style={{
                            height: '32px',
                            display: 'flex',
                            padding: '18px',
                            justifycontent: 'center',
                            alignitems: 'center',
                            gap: '6px',
                        }}
                        id="dispatchReportManageColumn"
                        tabIndex={0}
                        onClick={() => updateModal(true, 'showManageColumn')}>
                        <span tabIndex={0} style={{ display: 'flex', margin: '-3px' }}>
                            <AppsIcon />
                        </span>
                        <span tabIndex={0} style={{ fontWeight: 'bold' }}>
                            MANAGE COLUMNS
                        </span>
                    </Box>
                </Box>
                <Box
                    className="userReport-buttons"
                    style={{
                        display: 'flex',
                        width: '50%',
                        justifyContent: 'end',
                        alignItems: 'center',
                        paddingRight: '16px',
                    }}
                >
                    <>
                        <Box>
                            <Item>
                            <Button
                                variant="outlined"
                                sx={{ width: '100%' }}
                                className="receiveitembtn"
                                style={{border:'2px solid #fe5200',color:'#fe5200'}}
                                // disabled={disableExcel}
                                onClick={(e) => {
                                    e.preventDefault()
                                    exportToExcel({
                                        fileName: `${reportName} ${currentDateTime}.xlsx`,
                                        sheetName: 'BookingDeliveryTrackingReport',
                                        headersList: [header1, filterHeaders, detailedHeaders],
                                        dataList: [[], [filterObj], tableData],
                                    })
                                }}
                            >
                                Export to Excel
                            </Button>
                            </Item>
                        </Box>
                    </>
                </Box>
            </Box>
            <Stack style={{ padding: '10px 15px 10px 15px', maxHeight: '600px' }}>
                <VirtualizedTable
                    tableData={tableData}
                    headerContent={headerContent}
                    rowContent={bodyContent}
                    tableStyle={{ tableLayout: 'auto', width: '100%' }}
                    autoResize={true}
                />
                {openLrModal && <LRStatusModel setOpenLrModal={setOpenLrModal} LRTrackStatusData={LRTrackStatusData} />}
            </Stack>
        </>
    )
}
const mapStateToProps = (data) => ({ data })

const mapDispatchToProps = {
    updateModal,
}
export default connect(mapStateToProps, mapDispatchToProps)(BkngDelvryTrackingTable)
